var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.$style.wrapper},[(_vm.isLoading)?_c('Spinner',{class:_vm.$style.spinner,attrs:{"appearance":_vm.appearance}}):_vm._e(),_c('span',{class:[_vm.$style.text, ( _obj = {}, _obj[_vm.$style.isLoading] = _vm.isLoading, _obj )]},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.displayedText))]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }